import type { FieldError as RHFFieldError } from 'react-hook-form';
import styled from 'styled-components';
import { Colors } from '../../../../../assets';
import { FontSize } from '../../../../../assets/GlobalStyle/Variables';

type Props = { error?: RHFFieldError };

const ErrorText = styled.span`
  display: block;
  color: ${Colors.error};
  font-size: ${FontSize.small};
  margin-top: 2px;
`;

export const FieldError = ({ error }: Props) =>
  error ? <ErrorText>{error.message}</ErrorText> : null;
